/**
 * Monapix Keep Keep
 * Boostrap all necessary files and produce final
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

/**
 * _lodash
 * A modern JavaScript utility library delivering modularity, performance & extras.
 *
 * https://lodash.com/docs/4.17.5
 *
 */
window._ = require('lodash');

window.Popper = require('popper.js').default;
window.moment = require('moment')
window.Promise = require('promise')

/* Define Moment locales */
window.moment.defineLocale('en-short', {
    parentLocale: 'en',
    relativeTime: {
        future: 'in %s',
        past: '%s',
        s: '1s',
        m: '1m',
        mm: '%dm',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        M: '1 month ago',
        MM: '%d months ago',
        y: '1y',
        yy: '%dy'
    }
})

window.moment.locale('en')



// WEBPACK FOOTER //
// ./resources/js/bootstrap.js